import { render, staticRenderFns } from "./isf.vue?vue&type=template&id=0c54691d&scoped=true"
import script from "./isf.vue?vue&type=script&lang=js"
export * from "./isf.vue?vue&type=script&lang=js"
import style0 from "./isf.vue?vue&type=style&index=0&id=0c54691d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c54691d",
  null
  
)

export default component.exports